// Bootstrap raíz del FE.
// Wrappea el router con el AuthProvider. Todo lo demás vive en src/app/router.
// La verificación de `/health` que tenía este archivo se movió a /health
// (HomePage smoke test) tras el wire de auth en F0-3.

import { AppRoutes } from './app/router';
import { AuthProvider } from './lib/auth';
import { VerComoProvider } from './lib/ver-como';

export function App() {
  return (
    <AuthProvider>
      <VerComoProvider>
        <AppRoutes />
      </VerComoProvider>
    </AuthProvider>
  );
}
